import { render, staticRenderFns } from "./wisdomsz.vue?vue&type=template&id=34a70841&scoped=true&"
import script from "./wisdomsz.vue?vue&type=script&lang=js&"
export * from "./wisdomsz.vue?vue&type=script&lang=js&"
import style0 from "./wisdomsz.vue?vue&type=style&index=0&id=34a70841&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a70841",
  null
  
)

export default component.exports